export default {
    name: 'location_room',
    definition: {
        active: '',
        color: '',
        description: '',
        location: {
            jsonApi: 'hasOne',
            type: 'location',
        },
        location_id: '',
        max_patients: '',
        max_reservations: '',
    },
};
